import { render, staticRenderFns } from "./Appointments_Day.vue?vue&type=template&id=6389efe2&scoped=true&"
import script from "./Appointments_Day.vue?vue&type=script&lang=js&"
export * from "./Appointments_Day.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6389efe2",
  null
  
)

export default component.exports